'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _aphrodite = require('aphrodite');

var _index = require('../colors/index');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var styles = _aphrodite.StyleSheet.create({
  footer: {
    backgroundColor: _index.grayCool,
    padding: '30px 0px 60px',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    height: 41,
    '@media (max-width: 767px)': {
      height: 'auto'
    }
  },
  unorderedList: {
    display: 'inline-block',
    listStyle: 'none',
    margin: 0
  },
  listElement: {
    display: 'inline-block',
    fontFamily: '"Museo Sans", "Lucida Grande", Arial, sans-serif',
    fontSize: '0.85em',
    fontWeight: 500,
    paddingLeft: 5,
    paddingRight: 5,
    lineHeight: '2em',
    textAlign: '-webkit-match-parent',
    '@media (max-width: 767px)': {
      textAlign: 'left',
      width: '100%',
      float: 'left'
    }
  },
  link: {
    color: _index.grayMediumish,
    textTransform: 'uppercase',
    textDecorationLine: 'none'
  }
});

function Footer(props) {
  var links = props.links;
  var linkLis = links.map(function (link) {
    return _react2.default.createElement('li', {
      key: 'li-' + link.name,
      className: (0, _aphrodite.css)(styles.listElement)
    }, _react2.default.createElement('a', {
      href: link.href,
      className: (0, _aphrodite.css)(styles.link),
      'data-track': link.track,
      'data-track-link-click': link.trackLinkClick,
      'data-track-location': link.trackLocation
    }, link.name));
  });
  return _react2.default.createElement('footer', {
    className: (0, _aphrodite.css)(styles.footer)
  }, _react2.default.createElement('ul', {
    className: (0, _aphrodite.css)(styles.unorderedList)
  }, linkLis));
}

exports.default = Footer;
Footer.propTypes = {
  /** Array of footer links. */
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    href: _propTypes2.default.string.isRequired,
    track: _propTypes2.default.string,
    trackLinkClick: _propTypes2.default.string,
    trackLocation: _propTypes2.default.string
  })).isRequired
};